<template>
  <div>
    <vxe-grid
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:reportProcessed="{ row }">
        <el-tag
          size="mini"
          :type="row.reportProcessed === 'Y' ? 'success' : 'danger'"
        >
          {{ row.v_reportProcessed }}
        </el-tag>
      </template>
      <template v-slot:document="{ row: { documentId, documentUrl } }">
        <el-link
          v-if="documentId"
          :underline="false"
          type="primary"
          :href="documentUrl"
          target="_blank"
          style="font-size: 13px;"
        >
          {{ documentId }}
        </el-link>
      </template>
      <template v-slot:syncStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.syncStatus === 'Y'
              ? 'success'
              : row.syncStatus === 'E'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_syncStatus }}
        </el-tag>
      </template>
      <template v-slot:syncOssFile="{ row: { syncOssFileName, syncOssUrl } }">
        <el-link
          v-if="syncOssFileName"
          :underline="false"
          type="primary"
          :href="syncOssUrl"
          target="_blank"
          style="font-size: 13px;"
        >
          {{ syncOssFileName }}
        </el-link>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_view_details') || '查看详情'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="$emit('open-detail', row)"
            />
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
}
</script>
